import React, { Component, PropTypes } from 'react';
import cn from 'classnames';
import _ from 'lodash';

export default class Icon extends Component {
  render() {
    const { name, className } = this.props;
    let pathCount = 0;
    const nameTrim = _.trim(name);
    switch (nameTrim) {
      case 'tp-icon-teach':
      case 'tp-icon-review':
      case 'tp-icon-follower':
      case 'tp-icon-total-income':
      case 'tp-icon-income-transfer':
      case 'tp-icon-star-half':
        pathCount = 2;
        break;
      case 'tp-icon-student':
        pathCount = 4;
        break;
      case 'tp-icon-promotion':
        pathCount = 3;
        break;
      case 'tp-level-bronze':
      case 'tp-level-silver':
      case 'tp-level-gold':
      case 'tp-info-2':
      case 'tp-noti-time':
        pathCount = 9;
        break;
      case 'tp-noti-calendar':
      case 'tp-noti-calendar-timeout':
        pathCount = 5;
        break;
      case 'tp-noti-payment':
        pathCount = 8;
        break;
      case 'tp-noti-calendar-cancel':
        pathCount = 7;
        break;
      case 'tp-info-1':
        pathCount = 21;
        break;
      case 'tp-info-3':
        pathCount = 12;
        break;
      case 'tp-info-4':
        pathCount = 11;
        break;
      case 'tp-info-5':
        pathCount = 16;
        break;
      case 'tp-info-6':
      case 'tp-noti-reminder':
      case 'tp-noti-calendar-ok':
        pathCount = 6;
        break;
      default:
        pathCount = 0;
        break;
    }
    const paths = [];
    for (let i = 0; i < pathCount; i++) {
      paths.push(<span key={i} className={`path${i + 1}`} />);
    }
    // if (name === 'tp-icon-teach') {
    //   return (
    //     <i className={cn(name, className)}>
    //       <span className="path1" />
    //       <span className="path2" />
    //     </i>
    //   );
    // } else if (name === 'tp-icon-student') {
    //   return (
    //     <i className={cn(name, className)}>
    //       <span className="path1" />
    //       <span className="path2" />
    //       <span className="path3" />
    //       <span className="path4" />
    //     </i>
    //   );
    // } else if (name === 'tp-icon-review') {
    //   return (
    //     <i className={cn(name, className)}>
    //       <span className="path1" />
    //       <span className="path2" />
    //     </i>
    //   );
    // } else if (name === 'tp-icon-follower') {
    //   return (
    //     <i className={cn(name, className)}>
    //       <span className="path1" />
    //       <span className="path2" />
    //     </i>
    //   );
    // } else if (name === 'tp-icon-total-income') {
    //   return (
    //     <i className={cn(name, className)}>
    //       <span className="path1" />
    //       <span className="path2" />
    //     </i>
    //   );
    // } else if (name === 'tp-icon-income-transfer') {
    //   return (
    //     <i className={cn(name, className)}>
    //       <span className="path1" />
    //       <span className="path2" />
    //     </i>
    //   );
    // } else if (name === 'tp-icon-promotion') {
    //   return (
    //     <i className={cn(name, className)}>
    //       <span className="path1" />
    //       <span className="path2" />
    //       <span className="path3" />
    //     </i>
    //   );
    // }
    return <i className={cn(name, className)}>{paths}</i>;
  }
}
